window.Products.Clothing.CroppedPulloverHoodie = function() {
};
window.Products.Clothing.CroppedPulloverHoodie.inherits(window.Products.Clothing.Shirt);
window.Products.Clothing.CroppedPulloverHoodie.dpi = 150;
window.Products.Clothing.CroppedPulloverHoodie.has_3d = true;
window.Products.Clothing.CroppedPulloverHoodie.id = 116;
window.Products.Clothing.CroppedPulloverHoodie.slug = 'cropped-pullover-hoodie';
window.Products.Clothing.CroppedPulloverHoodie.syncColors = true;
window.Products.Clothing.CroppedPulloverHoodie.texturesLoaded = 0;
window.Products.Clothing.CroppedPulloverHoodie.texturesLoading = false;
window.Products.Clothing.CroppedPulloverHoodie.use_glb = true;

window.Products.Clothing.CroppedPulloverHoodie.prototype.outsideObject = 0;
window.Products.Clothing.CroppedPulloverHoodie.prototype.detailsObject = 1;
window.Products.Clothing.CroppedPulloverHoodie.prototype.position = 0.1;

window.Products.Clothing.CroppedPulloverHoodie.prototype.handleColorOption = function(modelViewer, color){
	var me = modelViewer.product;

	var object = modelViewer.object;
	if(!object) return;

	if(!color) {
		if(modelViewer.inlab){
			$('#button_options_color').find('img').attr('src', $(this).find('img').attr('src'));
			$('#container_options_color, #button_options_color').removeClass('active');
			color = $(this).attr('for');
		} else {
			color = $('#productInfo-productOption-color').find('option:selected').attr('data-slug');
		}
	}

	var three_color = me.getColor(color);
	//object.children[0].children[me.outsideObject].material.color = three_color;
	object.children[0].children[me.detailsObject].material.color = three_color;
	
	me.updateThreeTexture(modelViewer);

	object.children[0].children[me.outsideObject].material.aoMapIntensity = 1.5;
	object.children[0].children[me.detailsObject].material.aoMapIntensity = 0.1;
};

window.Products.Clothing.CroppedPulloverHoodie.prototype.getColor = function(_name){
	colors = {
		"blush": 0xf1d4d0,
		"black": 0x171616,
		"bone": 0xece6e2,
		"black_camo": 0x171616,
		"sage": 0x94abac,
	};

	return new THREE.Color(colors[_name]);
};

window.Products.Clothing.CroppedPulloverHoodie.prototype.getColorTexture = function(_name) {
	if(_name == "black_camo") return 1; // The is the index of the texture in the array in _Shirt.js
	else return null;
}